import map from "lodash/map";
import { ActivityConnectionsEvent, GenericDiff } from "PFTypes";

import { HistoryEntryTemplate } from "../../components/history_entry_template";
import { HistoryUpdatedAttributes } from "../../components/history_updated_attributes";
import { getTagRelatedEventDiff } from "./history_entry_activity_connections.utils";
import { useHumanizedAcitivityConnectionEventDiff } from "./use_humanized_acitivity_connection_event_diff";

export const HistoryEntryActivityConnections = ({ entry }: { entry: ActivityConnectionsEvent }) => {
  const isTagRelatedEvent = !!entry.metadata.activityTag;

  const diff = isTagRelatedEvent ? getTagRelatedEventDiff(entry) : entry.diff;

  const eventDiff = useHumanizedAcitivityConnectionEventDiff(diff);

  const renderHistoryContent = () =>
    map(eventDiff, (diff, key) => (
      <HistoryUpdatedAttributes
        label={key}
        level={1}
        updatedAttributes={diff as GenericDiff}
        metadata={entry.metadata}
      />
    ));

  return <HistoryEntryTemplate entry={entry}>{renderHistoryContent()}</HistoryEntryTemplate>;
};
